const paper = () => import('@/page/exam/exam-paper')
const paperresult = () => import('@/page/exam/exam-paper/paperresult.vue')
const examlist = () => import('@/page/exam/exam-list')
const exampractice = () => import('@/page/exam/exam-practice')
const exercise = () => import('@/page/exam/exerciseData')
export default [
  {
    path: '/paper',
    name: 'paper',
    component: paper,
    childred: []
  },
  {
    path: '/paperresult',
    name: 'paperresult',
    component: paperresult,
    childred: []
  },
  {
    path: '/examlist',
    name: 'examlist',
    component: examlist,
    childred: []
  },
  {
    path: '/exampractice',
    name: 'exampractice',
    component: exampractice,
    childred: []
  },
  {
    path: '/exercise',
    name: 'exercise',
    component: exercise,
    childred: []
  }
]



// WEBPACK FOOTER //
// ./src/router/exam/index.js